import { gql } from '@apollo/client';
import GqlClient from 'utils/graphqlService';
import _get from 'lodash/get';
import { setLocalData, getLocalData } from 'utils/localDataStore';
import _isEmpty from 'lodash/isEmpty';

const GET_IMAGE_BY_TITLE = gql`
  query Images($title: String!) {
    siteImagesCollection(where: { title: $title }, limit: 1) {
      items {
        title
        fontColor
        splashLarge {
          url
        }
        splashMedium {
          url
        }
        splashSmall {
          url
        }
      }
    }
  }
`;

export const getContentByType = (data, type) =>
  data.items.filter(item => item.sys.contentType.sys.id === type);

export const getImageByTitles = async titles => {
  const images = await Promise.all(
    titles.map(async ({ title }) => {
      try {
        const { data } = await GqlClient.query({
          query: GET_IMAGE_BY_TITLE,
          variables: {
            title,
          },
        });

        return _get(data, 'siteImagesCollection.items.0');
      } catch (error) {
        // ignore errors if a image wasn't found
        return null;
      }
    }),
  );
  return images;
};

export function getClientLandingImages(data) {
  if (_isEmpty(data)) return false;
  const objectImages = data.map(el => ({
    large: _get(el, 'fields.splashLarge.fields.file.url'),
    medium: _get(el, 'fields.splashMedium.fields.file.url'),
    small: _get(el, 'fields.splashSmall.fields.file.url'),
    fontColor: _get(el, 'fields.fontColor'),
    title: _get(el, 'fields.title'),
    altText: _get(el, 'fields.altText'),
    isTransparent: _get(el, 'fields.isTransparent', false),
  }));
  const imageIndexToShow = getImageIndex(objectImages, 'client');
  return objectImages[imageIndexToShow];
}

export function getClientLandingImagesGQl(data, shouldStaticBGImage) {
  if (_isEmpty(data)) return false;
  const objectImages = data.map(el => ({
    large: _get(el, 'splashLarge.url'),
    medium: _get(el, 'splashMedium.url'),
    small: _get(el, 'splashSmall.url'),
    fontColor: _get(el, 'fontColor'),
    title: el.title,
    altText: _get(el, 'altText'),
    isTransparent: _get(el, 'isTransparent', false),
  }));
  const imageIndexToShow = shouldStaticBGImage
    ? 0
    : getImageIndex(objectImages, 'client');
  return objectImages[imageIndexToShow];
}

function getImageIndex(images, type) {
  const homeImageIndexes = getLocalData(`${type}-image-index`);
  const homeImageIndexesArr = homeImageIndexes
    ? JSON.parse(homeImageIndexes)
    : [];
  if (images.length === 1 || homeImageIndexesArr.length > images.length) {
    setLocalData(`${type}-image-index`, JSON.stringify([0]), {
      expires: 365,
    });
    return 0;
  }
  const randomNumber = Math.floor(Math.random() * images.length + 0);
  if (homeImageIndexesArr.length === images.length) {
    setLocalData(`${type}-image-index`, JSON.stringify([]), {
      expires: 365,
    });
    return 0;
  }
  if (_isEmpty(homeImageIndexesArr)) {
    setLocalData(`${type}-image-index`, JSON.stringify([randomNumber]), {
      expires: 365,
    });
    return randomNumber;
  }
  if (!homeImageIndexesArr.includes(randomNumber)) {
    const newHomeImageIndexes = [...homeImageIndexesArr, randomNumber];
    setLocalData(`${type}-image-index`, JSON.stringify(newHomeImageIndexes), {
      expires: 365,
      secure: true,
      sameSite: 'strict',
    });
    return randomNumber;
  }
  return getImageIndex(images, type);
}

export function getClientHomeImages(data) {
  if (_isEmpty(data)) return false;
  const objectImages = data.map(({ fields }) => ({
    large: _get(fields, 'splashLarge.fields.file.url'),
    medium: _get(fields, 'splashMedium.fields.file.url'),
    small: _get(fields, 'splashSmall.fields.file.url'),
    fontColor: _get(fields, 'fontColor'),
  }));
  const imageIndexToShow = getImageIndex(objectImages, 'home');
  return objectImages[imageIndexToShow];
}
